import React, { Component } from 'react';
import Spinner from 'components/Spinner';

class Callback extends Component {
  render() {
    const style = {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
    };

    const imgStyle = {
      width: '60px',
    };

    return (
      <div style={style}>
        <div style={imgStyle}>
          <Spinner/>
        </div>
      </div>
    );
  }
}

export default Callback;
